import React, { useEffect, useRef, useState } from "react";
import { Pagination } from "@mui/material";
import { Flex } from "@100mslive/roomkit-react";
import ExploreList from "../Explore/ExploreList";
import FullPageProgress from "../FullPageProgress";
import { ToastManager } from "../Toast/ToastManager";
import { SESSION_AUTH } from "../../common/auth";
import { PROFILE_SERVICES } from "../../services";

const PublicProfileEvents = props => {
  const { profileId } = props;

  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const dataFetchedRef = useRef(false);
  const [listData, setListData] = useState([]);
  const [totalPage, setTotalPage] = useState(0);

  useEffect(() => {
    if (dataFetchedRef.current || !profileId) return;
    dataFetchedRef.current = true;
    setLoading(true);

    PROFILE_SERVICES.events({
      page: page,
      profileId: profileId,
      userId: isUserSession?.userId,
      org: isUserSession?.org?.id,
    })
      .then(data => {
        if (data.code === 200) {
          setListData(data.data?.list);
          if (data.data?.pageInfo?.page === 1) {
            setTotalPage(data.data?.pageInfo?.totalPage || 0);
          }
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page, profileId, isUserSession, LOGOUT_USER_SESSION]);

  const handleChangePage = (event, newPage) => {
    if (page === newPage) return;
    dataFetchedRef.current = false;
    setPage(newPage);
  };

  return (
    <React.Fragment>
      <div className="new-event-page-tabs-data mb-20">
        <ExploreList loading={loading} listData={listData} />
        {totalPage > 1 && (
          <Flex justify="center" className="text-center mt-20">
            <Pagination
              variant="text"
              onChange={handleChangePage}
              page={page}
              count={totalPage}
            />
          </Flex>
        )}

        {loading ? <FullPageProgress fixed={true} /> : null}
      </div>
    </React.Fragment>
  );
};

export default PublicProfileEvents;
